import { Eleicao } from './../models/eleicao.model';
import { STORAGE_KEYS } from '../core/config/storage-keys.config';
import { Injectable } from '@angular/core';
import { LocalUser } from '../core/config/localUser';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  getLocalUser(): LocalUser {
    let participante = sessionStorage.getItem(STORAGE_KEYS.localUser);
    if (participante == null) {
      return null;
    } else {
      return JSON.parse(participante);
    }
  }

  setLocalUser(participante: LocalUser) {
    if (participante == null) {
      sessionStorage.clear();
    } else {
      sessionStorage.setItem(STORAGE_KEYS.localUser, JSON.stringify(participante));
    }
  }

  getEleicao(): Eleicao {
    let eleicao = sessionStorage.getItem(STORAGE_KEYS.eleicao);
    if (eleicao == null) {
      return null;
    } else {
      return JSON.parse(eleicao);
    }
  }

  setEleicao(eleicao: Eleicao) {
    if (eleicao == null) {
      sessionStorage.clear();
    } else {
      sessionStorage.setItem(STORAGE_KEYS.eleicao, JSON.stringify(eleicao));
    }
  }


}
